"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _reactI18next = require("react-i18next");
var _moment = _interopRequireDefault(require("moment"));
var _svgicon = _interopRequireDefault(require("../../helper/svgicon"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useStyles = (0, _core.makeStyles)(theme => {
  var _theme$palette$backgr;
  return {
    day: {
      background: (_theme$palette$backgr = theme.palette.background) === null || _theme$palette$backgr === void 0 ? void 0 : _theme$palette$backgr.light,
      padding: theme.spacing(2)
    },
    top: {
      alignItems: "center",
      display: "flex",
      justifyContent: "space-between"
    },
    dateLabel: {
      color: theme.palette.primary.main,
      fontSize: "1.4rem",
      fontWeight: theme.typography.fontWeightBold
    },
    stateText: {
      marginLeft: theme.spacing(1),
      textAlign: "right"
    },
    icon: {
      display: "flex",
      justifyContent: "center",
      margin: theme.spacing(2, 0)
    },
    temps: {
      alignItems: "center",
      display: "flex",
      justifyContent: "center"
    },
    spacer: {
      background: theme.palette.grey[400],
      height: theme.spacing(4),
      margin: theme.spacing(0, 2),
      width: 1
    },
    tempMin: {
      textAlign: "right"
    },
    tempValue: {
      color: theme.palette.primary.main,
      fontSize: "1.6rem",
      fontWeight: theme.typography.fontWeightBold
    }
  };
});
const Weather = () => {
  const [weatherData, setWeatherData] = (0, _react.useState)();
  (0, _react.useEffect)(() => {
    async function fetchData() {
      const {
        REACT_APP_PATH
      } = process.env;
      const fetchURL = REACT_APP_PATH + "/Micado.Tourism.Web/Micado.Tourism.Web.IO.Api.WeatherApi/GetDetailsAsJson.api";
      const response = await fetch(fetchURL);
      try {
        setWeatherData(await response.json());
      } catch (error) {}
    }
    fetchData();
  }, []);
  if (!weatherData) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  }
  return /*#__PURE__*/_react.default.createElement(_core.Box, {
    my: 6
  }, weatherData.map(item => {
    return /*#__PURE__*/_react.default.createElement(WeatherStation, {
      key: item.name,
      stationData: item
    });
  }));
};
const WeatherStation = _ref => {
  let {
    stationData
  } = _ref;
  if (!stationData) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  }
  const {
    days
  } = stationData;
  return /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    spacing: 2
  }, days === null || days === void 0 ? void 0 : days.map(day => {
    return /*#__PURE__*/_react.default.createElement(Day, {
      key: day.date,
      dayData: day
    });
  }));
};
const Day = _ref2 => {
  let {
    dayData
  } = _ref2;
  const {
    date,
    state,
    temperatureMin,
    temperatureMax
  } = dayData;
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const css = useStyles();
  if (!date || typeof temperatureMin === "undefined" || typeof temperatureMax === "undefined") {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  }
  return /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12,
    md: 4
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: css.day
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: css.top
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: css.dateLabel
  }, (0, _moment.default)(new Date(date)).format("dddd")), /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "caption",
    component: "p"
  }, (0, _moment.default)(new Date(date)).format("DD.MM."))), /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: css.stateText,
    variant: "caption",
    component: "p"
  }, t("site.weather.stateText.".concat(state)))), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_svgicon.default, {
    className: css.icon,
    src: "/img/icons/weather/".concat(state, ".svg"),
    size: 128
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: css.temps
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: css.tempMin
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: css.tempValue
  }, temperatureMin, " \xB0C"), /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "caption",
    component: "p"
  }, t("site.weather.min"))), /*#__PURE__*/_react.default.createElement("div", {
    className: css.spacer
  }), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: css.tempValue
  }, temperatureMax, " \xB0C"), /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "caption",
    component: "p"
  }, t("site.weather.max")))))));
};
var _default = exports.default = Weather;